module.exports = __webpack_public_path__ + "img/user-logo.3bc5cff4.png";